import { Drawer } from "@xola/ui-kit";
import clsx from "clsx";
import { isMistPurchase } from "common";
import React from "react";
import { Purchase, PurchaseItem } from "types";
import { MerchandiseItemSidebar } from "@/components/Dashboard/MerchandiseDashboard/MerchandiseItemSidebar";
import { PurchaseItemDetails } from "@/components/PurchasesMenu/PurchaseItemDetails";
import { getMerchandisePurchaseItems } from "@/models/MerchandisePurchaseItem";

interface PurchaseDrawerProps {
    isOpen: boolean;
    selectedPurchase?: Purchase | null;
    selectedItem?: PurchaseItem | null;
    onContactInfoClick?: () => void;
    onClose: () => void;
}

export const PurchaseDrawer = ({
    isOpen,
    selectedPurchase,
    selectedItem,
    onContactInfoClick,
    onClose,
}: PurchaseDrawerProps) => {
    const isMist = selectedPurchase && isMistPurchase(selectedPurchase);
    const merchandiseItems = selectedPurchase ? getMerchandisePurchaseItems(selectedPurchase) : [];
    const showMerchandiseSidebar = isMist && merchandiseItems.length > 1;

    return (
        <Drawer
            size="2xl"
            isOpen={Boolean(isOpen && selectedPurchase)}
            content={
                Boolean(selectedPurchase) && (
                    <div className="flex h-full">
                        {showMerchandiseSidebar && (
                            <MerchandiseItemSidebar purchase={selectedPurchase!} selectedItemId={selectedItem?.id} />
                        )}
                        <div className={clsx("flex-1 overflow-y-auto", showMerchandiseSidebar && "pl-0")}>
                            <PurchaseItemDetails
                                isDrawer
                                purchase={selectedPurchase!}
                                item={selectedItem ?? undefined}
                                onContactInfoClick={onContactInfoClick}
                            />
                        </div>
                    </div>
                )
            }
            classNames={{
                dialog: "z-30",
                children: showMerchandiseSidebar ? "!p-0 w-screen md:max-w-7xl 2xl:max-w-screen-xl" : "",
            }}
            onClose={onClose}
        />
    );
};
